import { styled } from "styled-components";

export const NavAndFooterLayout = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100lvh;
`;
